var _clipPath, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextekLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.73461 0 0 .72727 -897.421 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M1221.63 0h272.253v275H1221.63z"
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1221.63 0h272.253v275H1221.63z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1408.096 87.808V75.584l-29.483-29.777V28.85h6.944l39.318 39.715v19.244h-16.78Zm16.78 17.568v19.352l-39.32 39.717h-6.943v-16.958l29.483-29.78v-12.331h16.78Zm-87.974-59.578-29.49 29.786v42.123l29.49 29.787v16.951h-6.95l-39.319-39.717V68.564l39.319-39.715h6.95v16.949Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281.842 219.469h-15.857l-11.212 11.212v5.252H245v-9.3l16.937-16.937h23.953l-4.048 9.773Z",
    style: {
      fill: "#1492ab"
    },
    transform: "matrix(1.42649 0 0 1.37656 967.022 -231.813)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1374.84 56.846 1399 80.16v7.702h-13.94v-2.13l-15.994-15.434 5.774-13.453ZM1330.452 100.33v7.23l15.994 15.434h22.62l15.994-15.434v-2.13H1399v7.702l-24.16 23.316h-34.168l-24.16-23.316V100.33h13.94ZM1385.057 92.925h39.818v7.441h-39.818zM1352.06 143.427v23.625h-7.367v-23.625zM1371.002 143.427v23.625h-7.367v-23.625zM1352.06 24.712v23.625h-7.367V24.712zM1371.002 24.712v23.625h-7.367V24.712z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 277.847,
    cy: 239.942,
    r: 16.588,
    transform: "matrix(1.02307 0 0 1.03339 1073.497 -151.308)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.074 0v-.716h.141l.293.478v-.478h.134V0H.497L.208-.467V0H.074Z",
    style: {
      fillRule: "nonzero"
    },
    transform: "matrix(68.4056 0 0 69.09563 1216.55 250.285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.073 0v-.716h.531v.121H.217v.159h.36v.121h-.36v.194h.4V0H.073Z",
    style: {
      fillRule: "nonzero"
    },
    transform: "matrix(68.4056 0 0 69.09563 1265.95 250.285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 .245-.374-.222-.342h.169l.143.23.141-.23h.168l-.223.348L.666 0H.491L.333-.248.173 0H0Z",
    style: {
      fillRule: "nonzero"
    },
    transform: "matrix(68.4056 0 0 69.09563 1311.577 250.285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.234 0v-.595H.021v-.121H.59v.121H.378V0H.234Z",
    style: {
      fillRule: "nonzero"
    },
    transform: "matrix(68.4056 0 0 69.09563 1357.203 250.285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.073 0v-.716h.531v.121H.217v.159h.36v.121h-.36v.194h.4V0H.073Z",
    style: {
      fillRule: "nonzero"
    },
    transform: "matrix(68.4056 0 0 69.09563 1398.988 250.285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.075 0v-.716h.144v.318l.292-.318h.195l-.27.279L.72 0H.533L.336-.336l-.117.12V0H.075Z",
    style: {
      fillRule: "nonzero"
    },
    transform: "matrix(68.4056 0 0 69.09563 1444.614 250.285)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextekLogo);
export default __webpack_public_path__ + "static/media/Nextek-logo.0abaa2c16cb08c6a3dd12e653579f362.svg";
export { ForwardRef as ReactComponent };